import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "36",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1F3B35",
      "fill-rule": "evenodd",
      d: "M22.63 23.898c-.47 0-.922-.072-1.348-.205-.038 4.84-3.987 8.768-8.837 8.768-4.872 0-8.836-3.965-8.836-8.837 0-4.873 3.964-8.837 8.836-8.837a8.85 8.85 0 0 1 7.228 3.751 4.5 4.5 0 0 1 2.32-1.585l.031-.022a11.7 11.7 0 0 0-5.333-4.19 7.35 7.35 0 0 0 2.285-5.33c0-4.067-3.31-7.376-7.376-7.376S4.224 3.344 4.224 7.411c0 .606.074 1.21.22 1.794l.088-.022a11.7 11.7 0 0 1 2.557-1.39 4.533 4.533 0 0 1 4.51-4.91 4.533 4.533 0 0 1 4.529 4.528c0 2.306-1.733 4.24-3.966 4.522v.01q-.054.001-.109.004-.223.023-.453.023l-.047.004-.21.018q-.714.068-1.401.219V7.446c-.968.001-1.923.122-2.847.355v5.44C3.337 15.187.76 19.11.76 23.625c0 6.443 5.241 11.685 11.684 11.685 6.438 0 11.676-5.233 11.685-11.668-.47.166-.975.257-1.5.257",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }